<template>
  <nav>
    <v-app-bar text class="secondary appbar" app>
      <v-app-bar-nav-icon
        x-large
        color="accent"
        class="ml-5"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase accent--text">
        <span class="black--text font-weight-bold">James Paul Gee</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      width="250px"
      class="secondary pt-4"
    >
      <v-row>
        <v-col cols="12" class="mt-5" justify="center" align="center">
          <v-avatar tile size="200">
            <v-img src="https://jamespaulgee.com/images/gee.jpg" alt />
          </v-avatar>
        </v-col>
      </v-row>
      <div class="mt-16" id="nav">
        <ul v-if="!isMobile()">
          <li>
            <v-icon> home </v-icon>
            <router-link to="/"> Home</router-link>
          </li>
          <li>
            <v-icon> mdi-information </v-icon>
            <router-link to="/About"> About</router-link>
          </li>
          <li>
            <v-icon> mdi-post-outline </v-icon>
            <router-link to="/Blogs"> Blogs</router-link>
          </li>
          <li>
            <v-icon> mdi-publish </v-icon>
            <router-link to="/Publications"> Publications</router-link>
          </li>
          <li>
            <v-icon> mdi-book-open </v-icon>
            <router-link to="/Books"> Books</router-link>
          </li>
          <li>
            <v-icon> mdi-bookshelf </v-icon>
            <router-link to="/Poems"> Poems</router-link>
          </li>
          <li>
            <v-icon> mdi-help </v-icon>
            <router-link to="/helpScrn"> Help</router-link>
          </li>
        </ul>
        <ul v-if="isMobile()">
          <li>
            <v-icon> home </v-icon>
            <router-link to="/"> Home</router-link>
          </li>
          <li>
            <v-icon> mdi-information </v-icon>
            <router-link to="/About"> About</router-link>
          </li>
          <li>
            <v-icon> mdi-post-outline </v-icon>
            <router-link to="/Mblogs"> Blogs</router-link>
          </li>
          <li>
            <v-icon> mdi-publish </v-icon>
            <router-link to="/Mpublications"> Publications</router-link>
          </li>
          <li>
            <v-icon> mdi-book-open </v-icon>
            <router-link to="/Mbooks"> Books</router-link>
          </li>
          <li>
            <v-icon> mdi-bookshelf </v-icon>
            <router-link to="/Mpoems"> Poems</router-link>
          </li>
          <li>
            <v-icon> mdi-help </v-icon>
            <router-link to="/helpScrn"> Help</router-link>
          </li>
        </ul>
      </div>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      snackbar: false,
      model: 0,
    };
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.appbar {
  float: left;
}

ul {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 16px;
  list-style-type: none;
}

li {
  margin-bottom: 10px;
  font-weight: bold;
}

a {
  color: #263238 !important;
  font-family: "PT Sans", Sans-Serif !important;
}

#nav a.router-link-exact-active {
  color: #b71c1c !important;
}

a:link {
  text-decoration: none;
}

a:hover {
  color: #e53935 !important;
}

.home {
  cursor: pointer;
}
</style>
